import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
    noticeToVacate: {},
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
